(function () {
  // ===== Editor-Erkennung (Overlay) =====
  const EDITOR_CLASS = 'printess-editor-open';
  function isEditorOpen() {
    const html = document.documentElement;
    return (
      html.classList.contains(EDITOR_CLASS) ||
      document.body.classList.contains(EDITOR_CLASS)
    );
  }

  function getVariantParam() {
    try {
      return new URLSearchParams(window.location.search).get('variant') || '';
    } catch (_) {
      return '';
    }
  }

  // ===== helpers =====
  const root =
    document.querySelector('variant-selects, form[data-type="add-to-cart-form"]') ||
    document;
  const q = (sel, r = root) => r.querySelector(sel);
  const qa = (sel, r = root) => Array.from(r.querySelectorAll(sel));

  const F_HANDLES = ['ausrichtung', 'formate', 'orientation'];
  const S_HANDLES = ['größe', 'groesse', 'size'];
  const TILE_HANDLES = ['kachelanzahl', 'kachelnanzahl', 'tile-count', 'tiles'];

  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim();

  function on(el, type, fn, opts) {
    if (!el) return () => {};
    el.addEventListener(type, fn, opts);
    return () => el.removeEventListener(type, fn, opts);
  }

  function findFs(handles, legendRE) {
    for (const h of handles) {
      const fs = q(`fieldset[data-handle="${h}"]`);
      if (fs) return fs;
    }
    return (
      qa('fieldset').find((fs) => {
        const lg = q('legend', fs);
        return lg && legendRE.test((lg.textContent || '').toLowerCase());
      }) || null
    );
  }

  function sizeSelect() {
    const fs = findFs(S_HANDLES, /größe|groe|size/);
    return fs ? q('select', fs) : null;
  }

  function orientationFieldset() {
    return findFs(F_HANDLES, /ausrichtung|format|orientation/);
  }

  function orientationEl() {
    const fs = orientationFieldset();
    if (!fs) return null;
    return q('select', fs) || q('input[type="radio"]:checked', fs) || null;
  }

  function getOrientationValue() {
    const el = orientationEl();
    if (!el) return '';
    const raw =
      el.tagName === 'SELECT'
        ? el.selectedOptions?.[0]?.textContent
        : el.getAttribute('value') || el.value || '';
    const t = norm(raw).toLowerCase();
    if (/hoch|portrait/.test(t)) return 'hoch';
    if (/quer|landscape/.test(t)) return 'quer';
    if (/quadr|square/.test(t)) return 'quadrat';
    return t;
  }

  const labelOf = (o) => norm(o?.textContent || '');
  const currentLabel = (sel) =>
    sel?.selectedOptions?.[0] ? labelOf(sel.selectedOptions[0]) : '';

  function optionLooksUnavailable(o) {
    if (!o) return true;
    const cls = (o.className || '').toLowerCase();
    return (
      o.disabled ||
      o.getAttribute('disabled') !== null ||
      o.getAttribute('aria-disabled') === 'true' ||
      cls.includes('unavailable') ||
      cls.includes('is-disabled') ||
      cls.includes('soldout') ||
      cls.includes('sold-out') ||
      /\bdisabled\b/.test(cls)
    );
  }

  function firstReallyEnabled(sel) {
    if (!sel) return null;
    return (
      Array.from(sel.options || []).find(
        (o) => o.value !== '' && labelOf(o) !== '' && !optionLooksUnavailable(o)
      ) || null
    );
  }

  function dispatchValueEvents(el, bubble = true) {
    if (!el) return;
    // Shopify Themes reagieren je nach Implementation auf input/change, meist bubbling nötig
    el.dispatchEvent(new Event('input', { bubbles: bubble }));
    el.dispatchEvent(new Event('change', { bubbles: bubble }));
  }

  // force=true => dispatch events even if value stays the same
  function selectOption(sel, opt, force = false) {
    if (!sel || !opt) return false;

    const sameValue = sel.value === opt.value;
    const unavailable = optionLooksUnavailable(opt);

    if (sameValue && !force && !unavailable) return true;

    sel.value = opt.value;
    dispatchValueEvents(sel, true);
    return true;
  }

  // ===== Size option hiding =====
  function hideUnavailableSizeOptions() {
    const sel = sizeSelect();
    if (!sel) return;

    Array.from(sel.options || []).forEach((o) => {
      if (!o.value) {
        o.hidden = false;
        return;
      }
      o.hidden = !!optionLooksUnavailable(o);
    });
  }

  // ===== Tiles =====
  function tilesSelect() {
    const fs = findFs(TILE_HANDLES, /kachel|tiles?/);
    return fs ? q('select', fs) : null;
  }

  function hideUnavailableTileOptions() {
    const sel = tilesSelect();
    if (!sel) return;

    Array.from(sel.options || []).forEach((o) => {
      if (!o.value) {
        o.hidden = false;
        return;
      }
      o.hidden = !!optionLooksUnavailable(o);
    });
  }

  function onPlacementChange() {
    if (isEditorOpen()) return;
    const sel = tilesSelect();
    if (!sel) return;

    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (isEditorOpen()) return;

        const cur = sel.selectedOptions && sel.selectedOptions[0];
        if (!cur || optionLooksUnavailable(cur)) {
          const first = firstReallyEnabled(sel);
          if (first) selectOption(sel, first);
        }
        hideUnavailableTileOptions();
      })
    );
  }

  // ===== label math helpers =====
  function extractWH(label) {
    const t = norm(label).toLowerCase().replace(/cm/g, '');
    const m = t.match(/(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i);
    if (!m) return null;
    const a = parseFloat(m[1].replace(',', '.'));
    const b = parseFloat(m[2].replace(',', '.'));
    if (isNaN(a) || isNaN(b)) return null;
    return [a, b];
  }

  function findOptionByLabelOrNumbers(sel, wantedLabel) {
    if (!sel || !wantedLabel) return null;
    const wantedNorm = norm(wantedLabel);
    const opts = Array.from(sel.options || []);

    // 1) exact label match
    let hit = opts.find((o) => labelOf(o) === wantedNorm) || null;
    if (hit) return hit;

    // 2) numeric match (e.g. "40 x 30 cm" vs "40×30")
    const wh = extractWH(wantedNorm);
    if (wh) {
      const [W, H] = wh;
      hit =
        opts.find((o) => {
          const oh = extractWH(labelOf(o));
          return oh && oh[0] === W && oh[1] === H;
        }) || null;
      if (hit) return hit;
    }

    return null;
  }

  // ===== Orientation set (select or radios) =====
  function setOrientationByKey(key) {
    const fs = orientationFieldset();
    if (!fs || !key) return false;

    // select
    const sel = q('select', fs);
    if (sel) {
      const opts = Array.from(sel.options || []);
      const wanted = opts.find((o) => {
        const t = norm(o.textContent).toLowerCase();
        if (key === 'hoch') return /hoch|portrait/.test(t);
        if (key === 'quer') return /quer|landscape/.test(t);
        if (key === 'quadrat') return /quadr|square/.test(t);
        return t === key;
      });
      if (wanted) {
        selectOption(sel, wanted, true);
        return true;
      }
      return false;
    }

    // radios
    const radios = qa('input[type="radio"]', fs);
    if (radios.length) {
      const wanted = radios.find((r) => {
        const v = norm(r.value).toLowerCase();
        const lbl = norm((r.closest('label')?.textContent || '')).toLowerCase();
        const t = (v + ' ' + lbl).trim();
        if (key === 'hoch') return /hoch|portrait/.test(t);
        if (key === 'quer') return /quer|landscape/.test(t);
        if (key === 'quadrat') return /quadr|square/.test(t);
        return t === key;
      });
      if (wanted) {
        wanted.checked = true;
        dispatchValueEvents(wanted, true);
        return true;
      }
    }

    return false;
  }

  // ===== State we keep =====
  let lastChosenSize = '';
  const selInit = sizeSelect();
  if (selInit) lastChosenSize = currentLabel(selInit);

  // Editor-change capture (NON-bubbling safe)
  let desiredOrientationFromEditor = '';
  let desiredSizeFromEditor = '';

  // Variant tracking for editor open/close
  let lastEditorOpen = isEditorOpen();
  let variantBeforeEditor = getVariantParam();

  // ===== Capture changes from Printess while overlay open =====
  // We cannot rely on document-level change, because Printess dispatches non-bubbling change events.
  let unbindSizeChange = null;
  let unbindOriChange = null;
  let sizeValueObserver = null;
  let oriValueObserver = null;

  function teardownDirectBindings() {
    if (unbindSizeChange) unbindSizeChange();
    if (unbindOriChange) unbindOriChange();
    unbindSizeChange = null;
    unbindOriChange = null;

    if (sizeValueObserver) sizeValueObserver.disconnect();
    if (oriValueObserver) oriValueObserver.disconnect();
    sizeValueObserver = null;
    oriValueObserver = null;
  }

  function bindDirectListenersToCurrentControls() {
    teardownDirectBindings();

    const s = sizeSelect();
    if (s) {
      // capture normal user changes (non-editor) too
      unbindSizeChange = on(s, 'change', () => {
        const lbl = currentLabel(s);
        if (lbl) lastChosenSize = lbl;
        if (isEditorOpen()) {
          desiredSizeFromEditor = lbl;
        }
      });

      // capture programmatic changes (selected attr, value)
      sizeValueObserver = new MutationObserver(() => {
        const lbl = currentLabel(s);
        if (isEditorOpen() && lbl) desiredSizeFromEditor = lbl;
      });
      sizeValueObserver.observe(s, {
        attributes: true,
        attributeFilter: ['value'],
        childList: true,
        subtree: true,
      });
    }

    const o = orientationEl();
    if (o) {
      unbindOriChange = on(o, 'change', () => {
        if (isEditorOpen()) {
          desiredOrientationFromEditor = getOrientationValue();
        }
      });

      oriValueObserver = new MutationObserver(() => {
        if (isEditorOpen()) {
          desiredOrientationFromEditor = getOrientationValue();
        }
      });
      oriValueObserver.observe(o, {
        attributes: true,
        attributeFilter: ['value', 'checked', 'selected'],
        childList: true,
        subtree: true,
      });
    }
  }

  // Controls can be re-rendered by theme → watch root
  const controlRebindObserver = new MutationObserver(() => {
    bindDirectListenersToCurrentControls();
  });
  controlRebindObserver.observe(root, { childList: true, subtree: true });

  // initial bind
  bindDirectListenersToCurrentControls();

  // ===== Sticky pick (used only when we explicitly need to correct invalid state) =====
  function stickyPick(sel, wantedOpt, timeoutMs) {
    const deadline = performance.now() + timeoutMs;
    let picked = false;

    const tryPick = () => {
      if (isEditorOpen()) return false;
      if (!wantedOpt || optionLooksUnavailable(wantedOpt)) return false;
      if (sel.value !== wantedOpt.value) {
        selectOption(sel, wantedOpt, true);
      } else {
        // even if same: ensure Shopify recalculates when needed
        dispatchValueEvents(sel, true);
      }
      picked = true;
      return true;
    };

    tryPick();

    const obs = new MutationObserver(() => {
      if (!isEditorOpen()) tryPick();
    });
    obs.observe(sel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled', 'value'],
    });

    let rafId;
    (function tick() {
      if (picked || performance.now() >= deadline || isEditorOpen()) {
        obs.disconnect();
        if (rafId) cancelAnimationFrame(rafId);
        return;
      }
      tryPick();
      rafId = requestAnimationFrame(tick);
    })();
  }

  // ===== When orientation changes on PDP (user interaction) =====
  function onOrientationChange() {
    if (isEditorOpen()) return;
    const sel = sizeSelect();
    if (!sel) return;

    // if current selection becomes invalid after orientation switch -> choose first valid
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (isEditorOpen()) return;

        const cur = sel.selectedOptions && sel.selectedOptions[0];
        if (!cur || optionLooksUnavailable(cur)) {
          const first = firstReallyEnabled(sel);
          if (first) {
            selectOption(sel, first, true);
            lastChosenSize = labelOf(first);
          }
        }
        hideUnavailableSizeOptions();
      })
    );
  }

  // ===== initial apply (no forced jumping) =====
  if (!isEditorOpen()) {
    hideUnavailableSizeOptions();
    hideUnavailableTileOptions();
  }

  // Observe disabled/class changes for hiding
  const selForHide = sizeSelect();
  if (selForHide) {
    const hideObserver = new MutationObserver(() => {
      if (isEditorOpen()) return;
      hideUnavailableSizeOptions();
    });
    hideObserver.observe(selForHide, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
    });
  }

  const tilesSel = tilesSelect();
  if (tilesSel) {
    const tileObserver = new MutationObserver(() => {
      if (isEditorOpen()) return;
      hideUnavailableTileOptions();
    });
    tileObserver.observe(tilesSel, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class', 'aria-disabled'],
    });
  }

  // ===== document listeners for normal user changes (bubbling ok) =====
  // only for fallback – Printess changes are non-bubbling, captured separately
  on(
    document,
    'change',
    (e) => {
      if (isEditorOpen()) return;
      const fs = e.target.closest('fieldset');
      if (!fs) return;
      const handle = (fs.getAttribute('data-handle') || '').toLowerCase();
      const legend = (q('legend', fs)?.textContent || '').toLowerCase();

      if (F_HANDLES.includes(handle) || /ausrichtung|format|orientation/.test(legend)) {
        onOrientationChange();
      }
    },
    true
  );

  on(
    document,
    'change',
    (e) => {
      if (isEditorOpen()) return;
      const fs = e.target.closest('fieldset');
      if (!fs) return;
      const handle = (fs.getAttribute('data-handle') || '').toLowerCase();
      const legend = (q('legend', fs)?.textContent || '').toLowerCase();

      if (handle.includes('platzierung') || /platzierung/.test(legend)) {
        onPlacementChange();
      }
    },
    true
  );

  // ===== Core: resync after editor close =====
  function applyEditorSelectionAfterClose() {
    if (isEditorOpen()) return;

    const sel = sizeSelect();

    // If Printess didn't deliver anything, do nothing (prevents "jump to first" on reload)
    const wantOri = desiredOrientationFromEditor;
    const wantSize = desiredSizeFromEditor;

    // 1) Apply orientation first (only if we captured it)
    if (wantOri) {
      setOrientationByKey(wantOri);
    }

    // 2) Wait until theme has rebuilt size options, then apply size (if captured)
    const applySize = () => {
      if (isEditorOpen()) return;
      if (!sel) return;

      if (!wantSize) return;

      const desiredOpt = findOptionByLabelOrNumbers(sel, wantSize);

      if (desiredOpt && !optionLooksUnavailable(desiredOpt)) {
        stickyPick(sel, desiredOpt, 900);
        lastChosenSize = labelOf(desiredOpt);
      } else {
        // If the exact size isn't present yet, don't fall back to first here.
        // Better to wait a bit; falling back is exactly what you don't want.
        // We'll do one more short delayed attempt.
        setTimeout(() => {
          if (isEditorOpen()) return;
          const sel2 = sizeSelect();
          if (!sel2) return;
          const desiredOpt2 = findOptionByLabelOrNumbers(sel2, wantSize);
          if (desiredOpt2 && !optionLooksUnavailable(desiredOpt2)) {
            stickyPick(sel2, desiredOpt2, 900);
            lastChosenSize = labelOf(desiredOpt2);
          } else {
            // last resort: if selected is invalid, then pick first valid
            const cur = sel2.selectedOptions && sel2.selectedOptions[0];
            if (!cur || optionLooksUnavailable(cur)) {
              const first = firstReallyEnabled(sel2);
              if (first) {
                selectOption(sel2, first, true);
                lastChosenSize = labelOf(first);
              }
            } else {
              // keep as-is
              dispatchValueEvents(sel2, true);
            }
          }
          hideUnavailableSizeOptions();
        }, 120);
      }
    };

    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (isEditorOpen()) return;

        hideUnavailableSizeOptions();
        hideUnavailableTileOptions();

        // Apply size slightly delayed, to let variant-selects rerender finish
        setTimeout(() => {
          hideUnavailableSizeOptions();
          applySize();
          hideUnavailableSizeOptions();
        }, 80);
      })
    );
  }

  // We still keep your "variantBeforeEditor" logic, but we no longer "force first".
  // We only correct if we have captured editor values OR current selection is invalid.
  function resyncAfterEditorClose() {
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        if (isEditorOpen()) return;

        hideUnavailableSizeOptions();
        hideUnavailableTileOptions();

        // If Printess didn't change URL variant, Shopify might not recalc price.
        // Instead of forcing first, we force-dispatch events on current selection.
        const before = variantBeforeEditor;
        const after = getVariantParam();
        if (before === after) {
          const sel = sizeSelect();
          if (sel) dispatchValueEvents(sel, true);
        }

        applyEditorSelectionAfterClose();
      })
    );
  }

  const editorStateObserver = new MutationObserver(() => {
    const nowOpen = isEditorOpen();

    // Editor opens
    if (!lastEditorOpen && nowOpen) {
      variantBeforeEditor = getVariantParam();
      desiredOrientationFromEditor = '';
      desiredSizeFromEditor = '';
    }

    // Editor closes
    if (lastEditorOpen && !nowOpen) {
      resyncAfterEditorClose();
    }

    lastEditorOpen = nowOpen;
  });

  editorStateObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
  editorStateObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Back/forward cache
  window.addEventListener('pageshow', () => {
    if (isEditorOpen()) return;
    // do not force anything on pageshow; only cleanup/hide
    hideUnavailableSizeOptions();
    hideUnavailableTileOptions();
  });
})();